<template>
  <div>
    <LayoutContent>
      <h2 class="secondary--text" :class="currentStep === 1 ? 'mb-1' : 'mb-10'">{{ $t('label.pointTransfer') }}</h2>
      <div class="d-flex flex-row mb-6" v-if="currentStep === 1">
        <SectionTitle :label="$t('label.transferTo') + ' :'" />
        <div class="ml-8 d-flex flex-row">
          <p class="text-h5 font-weight-bold">{{ selectedMember.name }}</p>
          <p class="text-h6 font-weight-medium ml-2">({{ trimPhoneNo(selectedMember.phone) }})</p>
        </div>
      </div>
      <v-card class="rounded-lg overflow-hidden elevation-3 white">
        <div v-if="currentStep === 0">
          <section class="pt-10 px-8 primary lighten-1">
            <div class="d-flex justify-center">
              <div class="m-auto" :class="!$vuetify.breakpoint.smAndUp ? 'w-100' : 'w-40'">
                <p class="text-h5 mb-4 white--text">{{ $t('label.transferTo') }}</p>
                <v-text-field
                  dense
                  v-model="mobileNum"
                  :label="$t('label.enterMobileNoOrUsername')"
                  outlined
                  rounded
                  class="stretch-append green-text-field-styling align-self-stretch white--text"
                  @input="onSearchChange"
                  background-color="#74ce00"
                  color="white"
                  filled
                  dark
                >
                  <template slot="prepend-inner">
                    <v-menu tile bottom offset-y left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn link text tile v-bind="attrs" v-on="on" class="pa-0 my-auto white--text" small>
                          {{ selectedCountry.phone_code }}
                          <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense tile class="pa-0">
                        <v-list-item v-for="country in countryList" :key="country.id" link active-class="white--text" @click="selectCountry(country)">
                          <v-list-item-title>{{ country.phone_code }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-text-field>
              </div>
            </div>
          </section>
          <v-divider class="mb-10 grey lighten-2" />
          <section class="px-8 mb-10 d-flex justify-center" style="min-height: 300px">
            <div v-if="memberList.length > 0" :class="!$vuetify.breakpoint.smAndUp ? 'w-100' : 'w-40'">
              <p class="text-h5" v-if="!isGlobalList">{{ $t('label.myTeamList') }}</p>
              <v-list class="transparent pa-0" two-line>
                <v-list-item v-for="member in memberList" :key="member.member_id" class="px-0" style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); background: transparent">
                  <v-list-item-content v-if="!isGlobalList" @click="selectTeamMember(member)">
                    <v-list-item-title class="font-weight-bold">{{ member.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ trimPhoneNo(member.phone) }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content v-else>
                    <v-list-item-title class="font-weight-bold">{{ trimPhoneNo(member.phone) }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action v-if="isGlobalList" @click="selectGlobalListMember(member)">
                    <app-button invert gradient :label="$t('label.select')" width="6rem"></app-button>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
            <div v-else class="d-flex" style="height: 250px">
              <p class="ma-auto text-h6 font-weight-medium">{{ $t('message.noUserRecord') }}</p>
            </div>
          </section>
        </div>
        <v-form ref="transferForm" v-else>
          <div class="coin-conversion--container">
            <div class="d-flex flex-column justify-center pa-8 primary lighten-1 white--text">
              <h4 class="text-center text-h5 font-weight-bold">{{ $t('label.availablePointBalance') }}</h4>
              <p class="text-center text-h6 font-weight-medium">{{ availablePoints }}</p>
            </div>
            <div class="pa-8 white-input">
              <p class="font-weight-bold text-subtitle-1">{{ $t('label.transferAmount') }}</p>
              <v-text-field
                v-model="form.point"
                placeholder="0"
                class="d-block mb-auto shrink primary--input text-h5 white-input"
                :rules="$rules.requiredRules"
                hide-details="auto"
                single-line
                :suffix="$t('label.points')"
                background-color="#fff"
              />
              <!-- <v-text-field
                v-model="form.point"
                placeholder="0"
                color="primary lighten-1"
                class="d-block mb-auto shrink primary--input text-h4"
                :rules="$rules.requiredRules"
                hide-details="auto"
                single-line
                :suffix="$t('label.points')"
                dark
              /> -->
            </div>
            <div class="coin-options--wrapper pa-8">
              <v-btn
                v-for="amount in presetPoints"
                depressed
                text
                outlined
                color="primary darken-1"
                class="coin-option font-weight-bold white"
                :key="amount"
                @click="form.point = amount"
                :disabled="amount > availablePoints"
              >
                {{ amount }} {{ $t('label.points') }}
              </v-btn>
            </div>
          </div>
        </v-form>
      </v-card>

      <!-- confirm transfer to non member -->
      <app-dialog v-model="isTransferToNonMember" :title="$t('label.transfer')" @click:outside="resetForm">
        <v-card-text class="d-flex flex-column align-center w-100">
          <p class="text-subtitle-1" v-if="selectedMember">
            {{ $t('message.confirmationToProceedTransferPoint', { name: selectedMember.name, phone: trimPhoneNo(selectedMember.phone) }) }}
          </p>
        </v-card-text>
        <v-card-actions class="d-flex flex-row align-stretch px-4 mt-10">
          <app-button invert gradient width="8rem" :label="$t('button.yes')" @click="onNext" />
          <app-button width="8rem" :label="$t('button.no')" @click="resetForm" />
        </v-card-actions>
      </app-dialog>

      <!-- confirm transfer point -->
      <app-dialog v-model="isConfirmTransfer" :title="$t('label.transfer')" @click:outside="isConfirmTransfer = false">
        <v-card-text class="d-flex flex-column align-center w-100">
          <p class="text-subtitle-1" v-if="selectedMember">
            {{ $t('message.confirmationTransferPointToUser', { name: selectedMember.name, point: form.point }) }}
          </p>
        </v-card-text>
        <v-card-actions class="d-flex flex-row align-stretch px-4 mt-10">
          <app-button invert gradient width="8rem" :label="$t('button.yes')" @click="confirmTransfer" />
          <app-button width="8rem" :label="$t('button.no')" @click="isConfirmTransfer = false" />
        </v-card-actions>
      </app-dialog>
    </LayoutContent>
    <bottom-bar>
      <v-container class="py-3 d-flex align-center justify-center" v-if="currentStep === 1">
        <app-button :label="$t('label.transferNow')" class="mr-2" width="12rem" @click="validateBeforeConfirm" :disabled="form.point === 0" />
      </v-container>
    </bottom-bar>
  </div>
</template>

<script>
import LayoutContent from '@/views/layouts/LayoutContent.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import { mapState, mapActions } from 'vuex'
import AppButton from '@/components/AppButton.vue'

export default {
  name: 'PointTransferAcknowledgement',
  components: { LayoutContent, SectionTitle, AppButton },
  data: () => ({
    presetPoints: [100, 500, 1000, 2000],
    availablePoints: 0,
    memberList: [],
    currentStep: 0,
    form: {
      to_member: '',
      point: 0
    },
    selectedCountry: {
      id: '',
      phone_code: ''
    },
    mobileNum: '',
    searchText: '',
    isGlobalList: false,
    selectedMember: null,
    isTransferToNonMember: false,
    isConfirmTransfer: false
  }),
  created() {
    this.getCountryList().then(() => {
      this.selectedCountry = {
        id: this.countryList[0].id,
        phone_code: this.countryList[0].phone_code
      }
    })
    this.fetchList()
  },
  computed: {
    ...mapState('common', ['countryList'])
  },
  methods: {
    ...mapActions('auth', ['getPointTransferMemberList', 'transferPoint']),
    ...mapActions('common', ['getCountryList']),
    onSearchChange(e) {
      this.searchText = e
      this.fetchList()
    },
    selectCountry(country) {
      this.selectedCountry = {
        id: country.id,
        phone_code: country.phone_code
      }
      this.fetchList()
    },
    fetchList() {
      this.getPointTransferMemberList({ country_code: this.selectedCountry.id, search: this.searchText }).then((res) => {
        this.memberList = res.list
        this.availablePoints = Number(res.points_available)
        this.isGlobalList = !res.from_team
      })
    },
    selectTeamMember(member) {
      this.setMember(member)
      this.currentStep = this.currentStep + 1
    },
    selectGlobalListMember(member) {
      this.setMember(member)
      this.isTransferToNonMember = true
    },
    setMember(member) {
      this.selectedMember = member
      this.form.to_member = member.member_id
    },
    onNext() {
      this.currentStep = this.currentStep + 1
      this.isTransferToNonMember = false
    },
    validateBeforeConfirm() {
      if (this.availablePoints > this.form.point) this.isConfirmTransfer = true
      else this.$toast.error(this.$t('error.notEnoughPointBalance'))
    },
    resetForm() {
      this.selectedMember = null
      this.searchText = ''
      this.isTransferToNonMember = false
    },
    confirmTransfer() {
      this.transferPoint(this.form)
        .then(() => {
          this.$router.push({ name: this.$constants.ROUTE_NAME.WALLET_POINT_TRANSFER_COMPLETE })
        })
        .catch(() => {
          this.isConfirmTransfer = false
          this.$toast.error(this.$t('error.transferPointFailed'))
        })
    },
    trimPhoneNo(number) {
      let phoneNum = number.slice(3)
      let sliceNumber = (phoneNum.length % 2 === 1 ? true : false) ? Math.round(phoneNum.length / 2) : phoneNum.length / 2
      let maskedNumber = phoneNum.slice(-sliceNumber).padStart(phoneNum.length, '*')
      return number.slice(0, 3).concat(maskedNumber)
    }
  }
}
</script>

<style lang="scss" scoped>
.coin-conversion--container {
  display: grid;
  grid-template-columns: 1fr;
  @media only screen and (min-width: 1000px) {
    grid-template-columns: 2fr 3fr 3fr;
  }
}

.coin-options--wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.coin-option {
  border-color: var(--v-primary-lighten1) !important;
}

.v-radio .theme--light {
  background-color: #fff !important;
}

// ::v-deep .v-text-field__slot > label {
//   background-color: var(--v-primary-lighten1) !important;
// }

// ::v-deep .v-text-field__slot > input {
//   background-color: var(--v-primary-lighten1) !important;
// }
::v-deep .v-input--selection-controls__input > i {
  background-color: #fff !important;
}

// ::v-deep .v-btn {
//   background-color: #fff !important;
// }

::v-deep .white-input > .v-input {
  background-color: #fff !important;
}

::v-deep .white-input > .v-btn {
  background-color: #fff !important;
}

::v-deep .theme--dark .v-label {
  color: #fff;

  .v-label--active {
    color: #fff;
    font-weight: 700;
  }
}

::v-deep .theme--dark.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: #fff;
}

::v-deep .theme--dark .v-label {
  color: #fff;
  background-color: var(--v-primary-lighten1) !important;
  font-weight: 500;

  .v-label--active {
    color: #fff;
    font-weight: 500;
    background-color: var(--v-primary-lighten1) !important;
  }
}

::v-deep .v-text-field--outlined.v-input--dense .v-label--active {
  color: #fff;
  font-weight: 600;
}

::v-deep .green-text-field-styling {
  .v-text-field--outlined.v-input--dense .v-label--active {
    border-color: 2px solid #fff;
  }

  .v-text-field__slot {
    font-size: 0.8rem !important;

    input {
      color: #fff;
      // color: var(--v-dark-green-base);
    }

    .v-label:not(.v-label--active) {
      font-size: 0.8rem !important;
      color: #fff;
      background-color: var(--v-primary-lighten1) !important;
    }
  }
}

::v-deep .v-application .theme--light {
  background-color: transparent !important;
}

// ::v-deep .v-input > .v-input__control > .v-text-field__details {
//   background-color: transparent !important;
// }
// ::v-deep i {
//   background-color: inherit !important;
// }
</style>
